module.exports = __webpack_public_path__ + "img/connection1.1ba8a170.png";